/**
 * Pure parsing for WS SIGNAL invite payloads — shared with tests and GlobalRealtimeProvider.
 * Server injects inviteId so pending uuid matches FCM / VoIP (see MessengerWebSocketHandler).
 */
type WsInviteParsed = {
  callerName: string;
  callMode: 'audio' | 'video';
  callScope: 'direct' | 'group';
  inviteId?: string;
  /** Название группы — звонящий кладёт его в групповое приглашение (E2E-8). */
  groupTitle?: string;
};

export function parseWsInvitePayload(rawPayload: unknown, defaultCallerName: string): WsInviteParsed {
  let callerName = defaultCallerName;
  let callMode: 'audio' | 'video' = 'audio';
  let callScope: 'direct' | 'group' = 'direct';
  let inviteId: string | undefined;
  let groupTitle: string | undefined;
  try {
    const p = JSON.parse(String(rawPayload ?? '{}')) as {
      callerName?: string;
      callMode?: string;
      callScope?: string;
      inviteId?: string;
      chatTitle?: string;
    };
    if (typeof p.callerName === 'string' && p.callerName.length > 0) {
      callerName = p.callerName;
    }
    if (p.callMode === 'audio' || p.callMode === 'video') {
      callMode = p.callMode;
    }
    if (p.callScope === 'group' || p.callScope === 'direct') {
      callScope = p.callScope;
    }
    if (typeof p.inviteId === 'string' && p.inviteId.length > 0) {
      inviteId = p.inviteId;
    }
    if (callScope === 'group' && typeof p.chatTitle === 'string' && p.chatTitle.trim().length > 0) {
      groupTitle = p.chatTitle.trim();
    }
  } catch {
    /* invalid JSON */
  }
  return { callerName, callMode, callScope, inviteId, ...(groupTitle ? { groupTitle } : {}) };
}

/** Pending CallKit/Telecom uuid: same rule as FCM foreground (inviteId ?? chatId ?? synthetic). */
export function nativeInvitePendingUuid(
  inviteId: string | undefined,
  chatId: string,
  nowMs: number,
): string {
  if (inviteId != null && inviteId.length > 0) {
    return inviteId;
  }
  if (chatId.length > 0) {
    return chatId;
  }
  return `call-${nowMs}`;
}
